export const types = {
  UPDATE_CHECKLIST_REVIEW: "UPDATE_CHECKLIST_REVIEW",
  // actionTypes.js
  SET_APPLICATION_DATA: "SET_APPLICATION_DATA", //Used for setting approved land use application data in purchasableFAR
};

export const updateChecklistReview = (data) => ({
  type: types.UPDATE_CHECKLIST_REVIEW,
  payload: data,
});
export const setApplicationData = (data, isLoading, error = null) => ({
  type: types.SET_APPLICATION_DATA,
  payload: { data, isLoading, error },
});
